import dayjs from "dayjs";
import type { TableColumnType } from "ant-design-vue";

import { PdpTypeLabel } from "@/app/reports/utils/enums";

export const listColumns: TableColumnType[] = [
  {
    title: "Fecha tipificación",
    dataIndex: "date",
    width: 180,
    customRender: ({ text }) => dayjs(text).format("DD/MM/YYYY"),
  },
  {
    title: "Hora tipificación",
    dataIndex: "hour",
    width: 180,
  },
  {
    title: "Contacto",
    dataIndex: ["contact_data", "name"],
    ellipsis: true,
    width: 220,
  },
  {
    title: "Código de contacto",
    dataIndex: ["contact_data", "code"],
    width: 180,
  },
  {
    title: "Código de producto",
    dataIndex: "account",
    width: 180,
  },
  {
    title: "Tipo de PDP",
    dataIndex: "pdp_type",
    width: 120,
    customRender: ({ text }) => {
      const index = text as keyof typeof PdpTypeLabel;
      return PdpTypeLabel[index];
    },
  },
  {
    title: "Fecha de PDP",
    dataIndex: "date_promise_to_pay",
    width: 120,
    customRender: ({ text }) => dayjs(text).format("DD/MM/YYYY"),
  },
  {
    title: "Monto de PDP",
    dataIndex: "amount_promise_to_pay",
    width: 120,
  },
  {
    title: "Usuario",
    dataIndex: ["user", "name"],
    width: 150,
    ellipsis: true,
  },
  {
    title: "Anexo ",
    dataIndex: ["user", "annex"],
    width: 80,
  },
  {
    title: "Tipo de contacto",
    dataIndex: "type_contact",
    width: 180,
  },
  {
    title: "Resultado",
    dataIndex: "result",
    width: 150,
    ellipsis: true,
  },
  {
    title: "Motivo",
    dataIndex: "motive",
    width: 150,
    ellipsis: true,
    customRender: ({ text }) => text || "-",
  },
  {
    title: "Submotivo",
    dataIndex: "submotive",
    width: 150,
    ellipsis: true,
    customRender: ({ text }) => text || "-",
  },
  {
    title: "Comentario de tipificacion",
    dataIndex: "comment",
    width: 220,
    ellipsis: true,
    customRender: ({ text }) => text || "-",
  },
];
